export default import.meta.ROLLUP_FILE_URL_dp06GqBHne2gZWNz1bENNg